import { useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const UNMERGE_ROUTE_PATH = `/unmerge/:pid(${pidRegexStr as PID})` as const

type UnmergeParams = PathParamMap<typeof UNMERGE_ROUTE_PATH>

export const useUnmergeParams = (): UnmergeParams => useParams<UnmergeParams>()
